/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
// eslint-disable-next-line no-restricted-imports
import { Trans } from '@lingui/macro'
import Circle from 'assets/images/blue-loader.svg'
import { ButtonRadioChecked } from 'components/Button'
import Tooltip from 'components/Tooltip'
import { DICE_SUBGRAPH_URL } from 'constants/subgraph'
import { formatDistanceToNowStrict } from 'date-fns'
import request, { gql } from 'graphql-request'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { ArrowDown, ArrowUp } from 'react-feather'
import { useDarkModeManager } from 'state/user/hooks'
import styled from 'styled-components/macro'
import { CustomLightSpinner, ThemedText } from 'theme'
import { shortenAddress } from 'utils'
import { isChainAllowed } from 'utils/switchChain'
import { countDecimals, tokenToDecimals } from 'utils/tokens'
import { isMobile } from 'utils/userAgent'

const DataContentWrapper = styled.main<{ isMobile?: boolean }>`
  width: 100%;
  background-color: ${({ theme }) => theme.bg0};
  border-radius: 8px;
  border: 1px solid #8247e5;
  padding: 16px;
  margin: auto;
`
const ResponsiveGrid = styled.div<{ isMobile?: boolean }>`
  display: grid;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  grid-template-columns: ${({ isMobile }) =>
    isMobile ? '1fr 1fr 1fr 1fr' : '0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr 0.6fr'};
  margin-bottom: 1rem;
`
const TableWrapper = styled.div`
  flex-direction: column;
`
const MyDataInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  padding: 16px;
`
const PageButtons = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`

const Arrow = styled.div`
  color: ${({ theme }) => theme.text1};
  padding: 0 20px;
  :hover {
    cursor: pointer;
  }
`

const Row = styled(ThemedText.Body)<{ isWallet?: boolean }>`
  text-align: center;
  color: ${({ isWallet, theme }) => (isWallet ? theme.yellow1 : '')};
`

const ButtonChecked = styled(ButtonRadioChecked)<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '10px' : '16px')};
  border-radius: 20px;
  border-color: #8247e5;
`

const QuestionWrapper = styled.div`
  display: flex;
  margin-left: 0.2rem;
  align-items: center;
  justify-content: center;
  padding: 0px;
  width: 18px;
  height: 18px;
  border: none;
  background: none;
  outline: none;
  cursor: default;
  border-radius: 36px;
  font-size: 12px;
  background-color: ${({ theme }) => theme.bg2};
  color: ${({ theme }) => theme.text2};

  :hover,
  :focus {
    opacity: 0.7;
  }
`

const QuestionMark = styled.span`
  font-size: 14px;
`

interface BetRow {
  id: string
  dateTime: string
  player: {
    id: string
  }
  amount: string
  bets: [
    {
      betType: string
      number: string
    }
  ]
  winNumber: string[] | undefined | null
  prize: string | undefined | null
}

interface Props {
  winNumber: string
}

const HistoryDice: React.FC<Props> = ({ winNumber }) => {
  const { account, chainId, connector } = useActiveWeb3React()
  const [isDark] = useDarkModeManager()
  const chainAllowed = chainId && isChainAllowed(connector, chainId)
  const [history, setHistory] = useState<BetRow[]>([])

  const apiUrl = DICE_SUBGRAPH_URL[chainAllowed ? chainId : 137]
  const [page, setPage] = useState(1)

  const [showOwed, setShowOwed] = useState<boolean>(false)
  const activeOwed = () => {
    setShowOwed(!showOwed)
    setPage(1)
  }

  useEffect(() => {
    request(
      apiUrl,
      gql`
        query {
          dices(first: 1) {
            bets(orderBy: dateTime, orderDirection: desc, first: 100) {
              id
              dateTime
              player {
                id
              }
              amount
              bets {
                betType
                number
              }
              winNumber
              prize
            }
          }
        }
      `
    )
      .then(({ dices }) => {
        if (dices.length > 0) {
          setHistory(dices[0].bets)
        }
      })
      .catch(({ error }) => {
        console.log(error)
      })
  }, [apiUrl, winNumber])

  const ITEMS = 10

  let betsMine = history
  if (showOwed) {
    betsMine = history?.filter((item) => item.player.id === account?.toLowerCase())
  }

  const sortedHistory = useMemo(() => {
    return betsMine.length > 0 ? betsMine.slice(ITEMS * (page - 1), page * ITEMS) : []
  }, [betsMine, page])

  const maxPage = sortedHistory.length > 0 ? Math.ceil(betsMine.length / ITEMS) : 0

  const [show, setShow] = useState(999)

  const open = useCallback((index: number) => setShow(index), [setShow])
  const close = useCallback((index: number) => setShow(index), [setShow])

  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          margin: 'auto',
          marginBottom: '0.4rem',
          width: '100%',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            marginLeft: '15%',
            width: '80%',
          }}
        >
          <ThemedText.LargeHeader textAlign="center" marginBottom="1rem">
            <Trans>History Bets</Trans>
          </ThemedText.LargeHeader>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'right',
            alignItems: 'right',
            width: isMobile ? '25%' : '20%',
          }}
        >
          {account ? (
            <ButtonChecked isMobile={isMobile} onClick={activeOwed} active={showOwed}>
              <ThemedText.Body fontSize={isMobile ? '10px' : '16px'}>
                <Trans>My Bets</Trans>
              </ThemedText.Body>
            </ButtonChecked>
          ) : (
            ''
          )}
        </div>
      </div>
      <DataContentWrapper isMobile={isMobile}>
        {history && history.length > 0 ? (
          <TableWrapper>
            {betsMine.length > 0 || sortedHistory.length > 0 ? (
              <ResponsiveGrid isMobile={isMobile}>
                {isMobile ? (
                  <>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Amount</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Bet</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Result</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Prize</Trans>
                    </ThemedText.Body>
                  </>
                ) : (
                  <>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Date</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Player</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Amount</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Bet</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Result</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Bets</Trans>
                    </ThemedText.Body>
                    <ThemedText.Body fontSize={isMobile ? '12px' : '16px'} textAlign="center">
                      <Trans>Prize</Trans>
                    </ThemedText.Body>
                  </>
                )}
              </ResponsiveGrid>
            ) : (
              ''
            )}
            {sortedHistory.length > 0 ? (
              <ResponsiveGrid isMobile={isMobile}>
                {sortedHistory.map((item, index) => {
                  const isMine = item.player.id === account?.toLowerCase()
                  const amount = tokenToDecimals(item.amount, 18)
                  const amountDecimals = countDecimals(amount)
                  const prize = tokenToDecimals(item.prize ?? '0', 18)
                  const prizeDecimals = countDecimals(prize)
                  const date = formatDistanceToNowStrict(parseInt(item.dateTime, 10) * 1000, {
                    addSuffix: true,
                  })
                  return (
                    <React.Fragment key={index}>
                      {isMobile ? (
                        <>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {amount.toFixed(amountDecimals > 2 ? 2 : amountDecimals)}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {item.bets[0].number}{' '}
                            {parseInt(item.bets[0].betType) === 0 ? <ArrowDown size={16} /> : <ArrowUp size={16} />}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {item.winNumber ? (
                              item.winNumber?.length > 1 ? (
                                <Tooltip text={item.winNumber?.toString()} show={index === show}>
                                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    {item.winNumber[0]}
                                    <QuestionWrapper
                                      onClick={() => open(index)}
                                      onMouseEnter={() => open(index)}
                                      onMouseLeave={() => close(999)}
                                    >
                                      <QuestionMark>+</QuestionMark>
                                    </QuestionWrapper>
                                  </div>
                                </Tooltip>
                              ) : (
                                item.winNumber?.toString()
                              )
                            ) : (
                              <CustomLightSpinner src={Circle} alt="loader" size={'10px'} />
                            )}
                          </Row>
                          <Row
                            fontSize={isMobile ? '10px' : '14px'}
                            isWallet={isMine}
                            color={
                              item.prize
                                ? amount === prize
                                  ? isDark
                                    ? '#fff'
                                    : '#000'
                                  : amount < prize
                                  ? '#27ae60'
                                  : '#fd3e3e'
                                : ''
                            }
                          >
                            {prize > 0 ? prize.toFixed(prizeDecimals > 2 ? 2 : prizeDecimals) : item.prize ? '0' : '-'}
                          </Row>
                        </>
                      ) : (
                        <>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {date}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {shortenAddress(item.player.id, 3)}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {amount.toFixed(amountDecimals > 2 ? 2 : amountDecimals)}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {item.bets[0].number}{' '}
                            {parseInt(item.bets[0].betType) === 0 ? <ArrowDown size={16} /> : <ArrowUp size={16} />}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {item.winNumber ? (
                              item.winNumber?.length > 1 ? (
                                <Tooltip text={item.winNumber?.toString()} show={index === show}>
                                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                    {item.winNumber[0]}
                                    <QuestionWrapper
                                      onClick={() => open(index)}
                                      onMouseEnter={() => open(index)}
                                      onMouseLeave={() => close(999)}
                                    >
                                      <QuestionMark>+</QuestionMark>
                                    </QuestionWrapper>
                                  </div>
                                </Tooltip>
                              ) : (
                                item.winNumber?.toString()
                              )
                            ) : (
                              <CustomLightSpinner src={Circle} alt="loader" size={'14px'} />
                            )}
                          </Row>
                          <Row fontSize={isMobile ? '10px' : '14px'} isWallet={isMine}>
                            {item.winNumber?.length}
                          </Row>
                          <Row
                            fontSize={isMobile ? '10px' : '14px'}
                            isWallet={isMine}
                            color={
                              item.prize
                                ? amount === prize
                                  ? isDark
                                    ? '#fff'
                                    : '#000'
                                  : amount < prize
                                  ? '#27ae60'
                                  : '#fd3e3e'
                                : ''
                            }
                          >
                            {prize > 0 ? prize.toFixed(prizeDecimals > 2 ? 2 : prizeDecimals) : item.prize ? '0' : '-'}
                          </Row>
                        </>
                      )}
                    </React.Fragment>
                  )
                })}
              </ResponsiveGrid>
            ) : (
              <MyDataInfo>
                <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} alignItems="center">
                  <Trans>You not have history</Trans>!
                </ThemedText.Body>
              </MyDataInfo>
            )}
            {betsMine.length > 0 || sortedHistory.length > 0 ? (
              <PageButtons>
                <Arrow
                  onClick={() => {
                    setPage(page === 1 ? page : page - 1)
                  }}
                >
                  <ThemedText.Body color={page === 1 ? 'text' : 'primary'}> {'<'} </ThemedText.Body>
                </Arrow>

                <ThemedText.Body>
                  <Trans>Page</Trans> {page} <Trans>of</Trans> {maxPage}
                </ThemedText.Body>
                <Arrow
                  onClick={() => {
                    setPage(page === maxPage ? page : page + 1)
                  }}
                >
                  <ThemedText.Body color={page === maxPage ? 'textDisabled' : 'primary'}> {'>'} </ThemedText.Body>
                </Arrow>
              </PageButtons>
            ) : (
              ''
            )}
          </TableWrapper>
        ) : (
          <MyDataInfo>
            <ThemedText.Body fontSize={isMobile ? '12px' : '18px'} alignItems="center">
              <Trans>No history</Trans>!
            </ThemedText.Body>
          </MyDataInfo>
        )}
      </DataContentWrapper>
    </>
  )
}

export default HistoryDice
